import { Link } from "react-router-dom";

export function PrivacyPage() {
  return (
    <section className="page legal-page">
      <h1>Privacy policy</h1>
      <p className="muted">
        This policy describes what information Predabet collects, how it’s used,
        and the choices you have.
      </p>

      <h2>Summary</h2>
      <ul>
        <li>
          <strong>We don’t sell your personal information.</strong>
        </li>
        <li>
          <strong>We use your Google sign-in email</strong> to associate your
          account preferences and Model Lab artifacts.
        </li>
        <li>
          <strong>We log basic usage and error data</strong> to keep the service
          reliable and secure.
        </li>
      </ul>

      <h2>Information we collect</h2>
      <ul>
        <li>
          <strong>Account info</strong>: Google email, display name, and profile
          image (if provided by Google).
        </li>
        <li>
          <strong>App data</strong>: UI preferences (display settings) and Model
          Lab configurations/runs you create.
        </li>
        <li>
          <strong>Technical data</strong>: IP address, device/browser metadata,
          and request logs for security and debugging.
        </li>
      </ul>

      <h2>How we use information</h2>
      <ul>
        <li>
          <strong>Provide the service</strong>: show predictions, save UI
          preferences, run Model Lab jobs.
        </li>
        <li>
          <strong>Improve reliability</strong>: monitor errors, investigate
          outages and performance issues.
        </li>
        <li>
          <strong>Security</strong>: prevent abuse, rate-limit, and detect
          suspicious activity.
        </li>
      </ul>

      <h2>Sharing</h2>
      <p>
        We may share information with service providers that help operate the
        site (hosting, logging/monitoring), only as needed to provide the
        service and protect it.
      </p>

      <h2>Your choices</h2>
      <ul>
        <li>
          <strong>Sign out</strong>: removes the local token stored in your
          browser.
        </li>
        <li>
          <strong>Browser storage</strong>: you can clear site storage to remove
          cached settings on this device.
        </li>
      </ul>

      <h2>Contact</h2>
      <p className="muted">
        Questions? Reach out to the site operator. (Add a support email when
        available.)
      </p>

      <p className="muted small" style={{ marginTop: "1rem" }}>
        Back to <Link to="/">Predictions</Link>. See also{" "}
        <Link to="/terms">Terms</Link> and{" "}
        <Link to="/responsible-gaming">Responsible gaming</Link>.
      </p>
    </section>
  );
}
